import type { Quantity } from '~/graphql/graphql';
import { formatLengthWithBasis, formatQuantityCell } from '~/utils';
import { BundleQuantityLabel } from '~/components/ui/BundleQuantityLabel';
import type { SummaryProduct } from '~/pages/buy-lists/sections/SummaryProductsPanel';
import type { BuyListDetailItem } from '~/pages/buy-lists/sections/types';
import { tallyQuantityAtCount } from '~/pages/buy-lists/sections/tallies/tallyQuantityAtCount';
import type { BuyListDetailTally } from '~/pages/buy-lists/sections/tallies/types';

export function toSummaryProduct(
  item: BuyListDetailItem,
  quantity: Quantity
): SummaryProduct {
  const platformProductsLength = item.platformProductsLength;
  return {
    id: item.id,
    name: platformProductsLength.platformProduct.name,
    lengthLabel: formatLengthWithBasis(
      platformProductsLength.lengthDisplayValue,
      platformProductsLength.isNominal
    ),
    quantityLabel: (
      <BundleQuantityLabel
        quantity={quantity}
        piecesPerBundle={item.effectivePiecesPerBundle}
        platformProductsLength={platformProductsLength}
      />
    ),
  };
}

export function toTallySummaryProduct(
  tally: BuyListDetailTally,
  tallyCount: number | null,
  tallyLabel: string
): SummaryProduct {
  const quantity = tallyQuantityAtCount(tally, tallyCount);
  const isCanned = tally.__typename === 'CannedBuyListTally';
  return {
    id: tally.id,
    name: tally.platformProduct.name,
    lengthLabel: isCanned ? tallyLabel : undefined,
    quantityLabel: formatQuantityCell(quantity.value, quantity.unit),
    tallyKind: isCanned ? 'canned' : 'random',
  };
}
